import { Container } from '@components/layout/grid'
import { Markdown } from '@components/markdown'
import { Text } from '@components/text'
import { TEXT } from '@lib/utils/text'
import type { FunctionComponent } from 'react'

import styles from './disclaimers.module.scss'

export const Disclaimers: FunctionComponent<DisclaimersProps> = ({
    defaults,
    starred,
    numbered,
    disclaimersMd,
}) => {
    // split on newlines and filter out empty strings
    const starredList = (starred ?? defaults).split(/\n/g).filter(Boolean)
    const numberedList = numbered ? numbered.split(/\n/g).filter(Boolean) : []

    return (
        <div className={styles['disclaimers-container']}>
            <Container>
                <ul className={styles.global}>
                    {starredList.map((item, index) => (
                        <li key={`${item}--${index}`}>
                            <Markdown
                                typeStyle='body-2xs'
                                tag='span'
                                color='dim'
                                markdown={item}
                            />
                        </li>
                    ))}
                </ul>

                {numbered?.length && (
                    <ol className={styles.disclaimers}>
                        {numberedList.map((item, index) => (
                            <li key={`${item}--${index}`}>
                                <Markdown
                                    typeStyle='body-2xs'
                                    tag='span'
                                    color='dim'
                                    markdown={item}
                                />
                            </li>
                        ))}
                    </ol>
                )}

                {disclaimersMd && (
                    <div className='disclaimersMd'>
                        <Markdown
                            typeStyle='body-2xs'
                            tag='p'
                            color='dim'
                            markdown={disclaimersMd}
                        />
                    </div>
                )}

                <Text typeStyle='body-2xs' tag='p' color='dim'>
                    {TEXT.footer.copyright}
                </Text>
            </Container>
        </div>
    )
}

export default Disclaimers

export interface DisclaimersProps {
    defaults: string
    starred?: string
    numbered?: string
    disclaimersMd?: string
}
